import Text from "@mobi/ds/components/Text"

import "./style.scss"

const LabelValueItem = ({ label = "", value = "", type = "", ...props }) => {
  if (type === "currency")
    return (
      <div className="labelValueItem" {...props}>
        <Text as="p" className="labelValueItem__label">
          {label}
        </Text>
        <Text className="labelValueItem__value--big">
          <span className="labelValueItem__currencySymbol" aria-hidden="true">
            R$
          </span>
          {value}
        </Text>
      </div>
    )

  return (
    <div className="labelValueItem" {...props}>
      <Text as="p" className="labelValueItem__label">
        {label}
      </Text>
      <Text className="labelValueItem__value">{value}</Text>
    </div>
  )
}

export default LabelValueItem
